<template>
  <div class="loading-transfer">
    <div>
      <loading />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingTransfer'
}
</script>

<style lang="scss">
.loading-transfer {
  margin-bottom: 15em;
}
</style>
